<template>
  <div class="cotizacion-view">

    <!-- Hero -->
    <header class="quote-hero">
      <img src="" alt="Grúas de construcción al atardecer" class="hero-bg-image">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <img src="/img/Logo.jpg" alt="Logo Tasoar" class="hero-logo">
        <h1>Estamos listos para construir <span>juntos</span> tu proyecto</h1>
        <p class="hero-subtitle">
          Completa el siguiente formulario y uno de nuestros asesores se pondrá en contacto contigo a la brevedad.
        </p>
      </div>
    </header>

    <!-- Barra de confianza -->
    <section class="quote-features-bar">
      <div class="features-bar-container">
        <div class="feature-item">
          <i class="fa-solid fa-shield-halved"></i>
          <div class="feature-text">
            <strong>COMPROMISO</strong>
            <span>Y CONFIANZA</span>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-solid fa-gear"></i>
          <div class="feature-text">
            <strong>SOLUCIONES</strong>
            <span>INTEGRALES</span>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-solid fa-helmet-safety"></i>
          <div class="feature-text">
            <strong>EXPERIENCIA</strong>
            <span>Y CALIDAD</span>
          </div>
        </div>
        <div class="feature-item">
          <i class="fa-solid fa-handshake"></i>
          <div class="feature-text">
            <strong>TRABAJAMOS</strong>
            <span>CONTIGO</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Formulario -->
    <section class="quote-form-section">
      <form class="quote-form" @submit.prevent="handleSubmit">

        <div class="form-grid">
          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-building"></i></div>
            <div class="field-content">
              <label for="empresa">NOMBRE DE LA EMPRESA:</label>
              <input id="empresa" type="text" v-model="form.empresa" placeholder="Escribe el nombre de la empresa">
            </div>
          </div>

          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-user"></i></div>
            <div class="field-content">
              <label for="contacto">NOMBRE DEL CONTACTO:</label>
              <input id="contacto" type="text" v-model="form.contacto" placeholder="Escribe el nombre del contacto">
            </div>
          </div>

          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-id-badge"></i></div>
            <div class="field-content">
              <label for="puesto">PUESTO DEL CONTACTO:</label>
              <input id="puesto" type="text" v-model="form.puesto" placeholder="Escribe el puesto del contacto">
            </div>
          </div>

          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-mobile-screen-button"></i></div>
            <div class="field-content">
              <label for="celular">CELULAR:</label>
              <input id="celular" type="tel" v-model="form.celular" placeholder="Ej. +52 477 123 4567">
            </div>
          </div>

          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-envelope"></i></div>
            <div class="field-content">
              <label for="correo">CORREO:</label>
              <input id="correo" type="email" v-model="form.correo" placeholder="Ej. contacto@empresa.com">
            </div>
          </div>

          <div class="field-group">
            <div class="field-icon"><i class="fa-solid fa-location-dot"></i></div>
            <div class="field-content">
              <label for="direccion">DIRECCIÓN:</label>
              <input id="direccion" type="text" v-model="form.direccion" placeholder="Escribe la dirección de la empresa">
            </div>
          </div>

          <div class="field-group field-group-full">
            <div class="field-icon"><i class="fa-solid fa-wrench"></i></div>
            <div class="field-content">
              <label for="servicio">SERVICIO:</label>
              <div class="select-wrapper">
                <select id="servicio" v-model="form.servicio">
                  <option value="" disabled>Selecciona el servicio de interés</option>
                  <option value="diseno">Diseño arquitectónico</option>
                  <option value="construccion">Construcción de obra civil</option>
                  <option value="supervision">Supervisión y gestión de proyectos</option>
                  <option value="mantenimiento">Mantenimiento industrial y comercial</option>
                  <option value="otro">Otro</option>
                </select>
                <i class="fa-solid fa-chevron-down select-arrow"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="upload-box">
          <div class="upload-info">
            <div class="field-icon"><i class="fa-solid fa-paperclip"></i></div>
            <div>
              <h3>ADJUNTAR ARCHIVO</h3>
              <p>Adjunta planos, documentos o cualquier archivo relacionado con tu proyecto.</p>
            </div>
          </div>

          <div class="upload-action">
            <label for="archivo" class="upload-button">
              <i class="fa-solid fa-upload"></i> SELECCIONAR ARCHIVO
            </label>
            <input id="archivo" type="file" class="visually-hidden" @change="handleFileChange">
            <p class="upload-hint">Formatos permitidos: PDF, DWG, JPG, PNG&nbsp;|&nbsp;Tamaño máximo: 20 MB</p>
            <p v-if="fileName" class="upload-filename">Archivo seleccionado: {{ fileName }}</p>
          </div>
        </div>

        <button type="submit" class="submit-button" :disabled="isSending">
          <span class="submit-icon"><i class="fa-solid fa-chevron-right"></i></span>
          {{ isSending ? 'ENVIANDO...' : 'ENVIAR SOLICITUD' }}
        </button>

        <p class="form-footer-text">
          En TASOAR, tu proyecto es nuestra prioridad. <span>¡Construyamos juntos grandes ideas!</span>
        </p>

        <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </form>
    </section>

  </div>
</template>

<script>
import emailjs from '@emailjs/browser';

// Reemplaza estos 3 valores con los que copiaste de tu cuenta de EmailJS
const EMAILJS_SERVICE_ID = 'service_3755oxt';
const EMAILJS_TEMPLATE_ID = 'template_tm37skn';
const EMAILJS_PUBLIC_KEY = 'R2FtQOl3zFrkCZHOC';

// Segundo correo de destino (mismo Public Key de cuenta, pero su propio Service/Template)
const EMAILJS_SERVICE_ID_2 = 'service_kz253u7';
const EMAILJS_TEMPLATE_ID_2 = 'template_kz253u7';

export default {
  name: 'ContactoView',
  created() {
    // Se inicializa una sola vez con tu Public Key
    emailjs.init(EMAILJS_PUBLIC_KEY);
  },
  data() {
    return {
      form: {
        empresa: '',
        contacto: '',
        puesto: '',
        celular: '',
        correo: '',
        direccion: '',
        servicio: '',
        archivo: null
      },
      fileName: '',
      isSending: false,
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      this.form.archivo = file || null;
      this.fileName = file ? file.name : '';
    },
    async handleSubmit() {
      this.isSending = true;
      this.errorMessage = '';

      const templateParams = {
        empresa: this.form.empresa,
        contacto: this.form.contacto,
        puesto: this.form.puesto || 'No especificado',
        celular: this.form.celular || 'No especificado',
        correo: this.form.correo,
        direccion: this.form.direccion || 'No especificada',
        servicio: this.form.servicio || 'No especificado',
        reply_to: this.form.correo
      };

      try {
        // Se mandan los dos correos en paralelo (cada uno a su propio Service/Template)
        const resultados = await Promise.allSettled([
          emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams),
          emailjs.send(EMAILJS_SERVICE_ID_2, EMAILJS_TEMPLATE_ID_2, templateParams)
        ]);

        const fallos = resultados.filter(r => r.status === 'rejected');

        if (fallos.length === resultados.length) {
          // Fallaron los dos envíos
          throw fallos[0].reason;
        }

        if (fallos.length > 0) {
          // Al menos uno de los dos falló; lo registramos pero no bloqueamos el éxito
          console.error('Uno de los correos no se pudo enviar:', fallos[0].reason);
        }

        this.successMessage = `¡Gracias${this.form.contacto ? ', ' + this.form.contacto : ''}! Hemos recibido tu solicitud, pronto te contactaremos.`;
        this.form = { empresa: '', contacto: '', puesto: '', celular: '', correo: '', direccion: '', servicio: '', archivo: null };
        this.fileName = '';
        setTimeout(() => { this.successMessage = ''; }, 6000);
      } catch (error) {
        console.error('Error al enviar la cotización:', error);
        this.errorMessage = 'Hubo un problema al enviar tu solicitud. Por favor intenta de nuevo.';
      } finally {
        this.isSending = false;
      }
    }
  }
};
</script>

<style scoped>
.cotizacion-view {
  color: #2c3e50;
}

/* --- Hero --- */
.quote-hero {
  position: relative;
  min-height: 340px;
  display: flex;
  align-items: center;
  overflow: hidden;
  background-color: var(--color-primary);
}

.hero-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(0,30,77,0.97) 0%, rgba(0,30,77,0.85) 45%, rgba(0,30,77,0.35) 75%, rgba(0,30,77,0.05) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 50px 60px;
  max-width: 900px;
  color: #ffffff;
}

.hero-logo {
  height: 50px;
  width: auto;
  margin-bottom: 20px;
  display: block;
}

.hero-content h1 {
  font-size: 2.6rem;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0 0 18px 0;
  text-shadow: 2px 2px 6px rgba(0,0,0,0.4);
  position: relative;
  padding-bottom: 18px;
}

.hero-content h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 70px;
  height: 4px;
  background-color: var(--color-text);
}

.hero-content h1 span {
  color: var(--color-text);
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #e3ecf7;
  max-width: 560px;
  margin: 0;
  line-height: 1.5;
}

/* --- Barra de confianza --- */
.quote-features-bar {
  background-color: var(--color-primary);
  padding: 25px 20px;
  border-top: 1px solid rgba(255,255,255,0.08);
}

.features-bar-container {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1 220px;
  padding: 10px 25px;
}

.feature-item:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.feature-item i {
  font-size: 2rem;
  color: #ffffff;
  flex-shrink: 0;
}

.feature-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.feature-text strong {
  font-size: 0.95rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.feature-text span {
  font-size: 0.85rem;
  color: #cfe0f5;
  font-weight: 600;
}

/* --- Formulario --- */
.quote-form-section {
  background-color: #ffffff;
  padding: 60px 20px 80px;
}

.quote-form {
  max-width: 1300px;
  margin: 0 auto;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px 40px;
  margin-bottom: 35px;
}

.field-group-full {
  grid-column: 1 / -1;
}

.field-group {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.field-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  background-color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 1.2rem;
}

.field-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.field-content label {
  font-weight: 800;
  font-size: 0.85rem;
  color: var(--color-primary);
  letter-spacing: 0.3px;
  text-align: left;
}

.field-content input,
.field-content select {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #d7dee6;
  border-radius: 6px;
  font-size: 0.95rem;
  font-family: inherit;
  color: #333;
  box-sizing: border-box;
  background-color: #ffffff;
}

.field-content input:focus,
.field-content select:focus {
  outline: none;
  border-color: var(--color-text);
  box-shadow: 0 0 0 3px rgba(9, 113, 237, 0.15);
}

.field-content input::placeholder {
  color: #a3adba;
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 40px;
  cursor: pointer;
}

.select-arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-primary);
  pointer-events: none;
  font-size: 0.85rem;
}

/* --- Adjuntar archivo --- */
.upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  border: 2px dashed #b9c6d6;
  border-radius: 10px;
  padding: 25px 30px;
  margin-bottom: 35px;
}

.upload-info {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  text-align: left;
}

.upload-info h3 {
  margin: 0 0 6px 0;
  font-size: 1.1rem;
  color: var(--color-primary);
}

.upload-info p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.upload-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.upload-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: var(--color-primary);
  color: #ffffff;
  padding: 14px 28px;
  border-radius: 8px;
  font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 0.9rem;
  transition: background-color 0.3s;
}

.upload-button:hover {
  background-color: var(--color-text);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.upload-hint {
  margin: 0;
  font-size: 0.8rem;
  color: #888;
  text-align: right;
}

.upload-filename {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text);
  font-weight: 600;
}

/* --- Botón enviar --- */
.submit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  background-color: var(--color-primary);
  color: #ffffff;
  border: none;
  border-radius: 50px;
  padding: 18px 30px;
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #00285e;
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: #ffffff;
  color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.form-footer-text {
  text-align: center;
  margin-top: 20px;
  color: #444;
  font-size: 0.95rem;
}

.form-footer-text span {
  color: var(--color-text);
  font-weight: 700;
}

.success-message {
  text-align: center;
  margin-top: 20px;
  color: var(--color-primary);
  font-weight: 700;
}

.error-message {
  text-align: center;
  margin-top: 20px;
  color: #b3261e;
  font-weight: 700;
}

/* --- Responsivo --- */
@media (max-width: 1100px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .hero-content h1 {
    font-size: 2rem;
  }

  .features-bar-container {
    flex-direction: column;
  }

  .feature-item {
    justify-content: flex-start;
  }

  .feature-item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 15px;
  }
}

@media (max-width: 768px) {
  .quote-hero {
    min-height: auto;
  }

  .hero-content {
    padding: 40px 25px;
  }

  .hero-content h1 {
    font-size: 1.7rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .upload-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .upload-action {
    align-items: flex-start;
    width: 100%;
  }

  .upload-button {
    width: 100%;
    justify-content: center;
  }

  .upload-hint {
    text-align: left;
  }

  .submit-button {
    font-size: 1.1rem;
    padding: 16px 20px;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.4rem;
  }

  .hero-logo {
    height: 38px;
  }

  .field-icon {
    width: 42px;
    height: 42px;
    font-size: 1rem;
  }

  .submit-button {
    font-size: 1rem;
    gap: 10px;
  }
}
</style>